module.exports = __webpack_public_path__ + "static/media/info_02.85790429.jpg";